// Custom hook for authentication-related functionality
import { useKeycloak } from "@react-keycloak/web";
import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export const useAuth = () => {
  const { keycloak } = useKeycloak();
  const toast = useToast();
  const navigate = useNavigate();

  const userName =
    keycloak.tokenParsed?.email || keycloak.tokenParsed?.preferred_username;

  const handleLogout = () => {
    // Logout initiated
    keycloak.logout();
    toast({
      title: "Logged out successfully",
      status: "info",
      duration: 3000,
      isClosable: true,
      position: "top",
      containerStyle: { marginTop: "20px" },
    });
  };

  const handleEditSignature = (signature) => {
    // Single route now handles both create and edit modes automatically
    navigate("/edit-signature");
  };

  return {
    userName,
    handleLogout,
    handleEditSignature,
    keycloak,
  };
};
